// Sai krishna 11/17/2022 2700271704 Action dropdown -- Dynamically rendered fields -- Untie from route section.
// Sai krishna 11/17/2022 2700271704 Action dropdown -- Validation bug fixes.
// Sai Maheshwar 11/20/2022 2700271704 fixed add action bugs and added validations
// Raghu 02/22/2023 2700271704 added new class to input fields
// Prakash 10-05-23 2700271704 add theme class name.


import {FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select} from '@material-ui/core';
import React, {useContext} from 'react';
import {ThemeContext} from '../../../../../themes/ThemeProvider';

const UntieFromRoute = (props) => {
  const applyToOptions = [{key: 'A', value: 'A - Account'}];

  const {values, touched, errors, handleChange, handleBlur} = props;
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  return (
    <>
      <Grid
        item
        xs={4}
        sm={4}
        className={`form-group ${classes.selectField}`}
      >
        <FormControl variant="outlined" fullWidth>
          <InputLabel id="demo-simple-select-label" required>
            Apply To
          </InputLabel>
          <Select
            fullWidth
            name="applyTo"
            className={`select-gender ${classes.labelName}`}
            value={values?.applyTo || 'none'}
            onChange={handleChange}
            placeholder="Select ApplyTo"
            id="demo-simple-select"
            labelId="demo-simple-select-label"
            onBlur={handleBlur}
            touched={touched?.applyTo}
            // error={Boolean(touched?.applyTo && errors?.applyTo)}
            label={'Select Apply To'}
          >
            <MenuItem value="none" key="none" disabled>
              <span className="defaultSelected"> Select Apply To </span>
            </MenuItem>
            {applyToOptions.map((option) => {
              return (
                <MenuItem value={option.key} key={option.key}>
                  {option.value}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormHelperText>{touched?.applyTo && errors && errors?.applyTo}</FormHelperText>
      </Grid>
    </>
  );
};

export default UntieFromRoute;
